export default "__VITE_ASSET__BjpexNyo__"